import Vue from 'vue'
import { API_URL } from '../../api'
import InvestorContractsFilter from '../../filters/InvestorContractsFilter';
import ProjectContractsFilter from '../../filters/ProjectContractsFilter';

const state = {
    investorContractCreate: {
        createdInvestorContract: null,
        creatingInvestorContract: false,
        createInvestorContractStatus: null
    },
    investorContractUpdate: {
        updatedInvestorContract: null,
        updatingInvestorContract: false,
        updateInvestorContractStatus: null
    },
    investorContractDelete: {
        deletingInvestorContract: false,
        deleteInvestorContractStatus: null
    },
    investorContractSearch: {
        investorContractsCount: null,
        investorContracts: [],
        searchingInvestorContracts: false,
        searchInvestorContractStatus: null
    },
    projectContractCreate: {
        createdProjectContract: null,
        creatingProjectContract: false,
        createProjectContractStatus: null
    },
    projectContractUpdate: {
        updatedProjectContract: null,
        updatingProjectContract: false,
        updateProjectContractStatus: null
    },
    projectContractDelete: {
        deletingProjectContract: false,
        deleteProjectContractStatus: null
    },
    projectContractSearch: {
        projectContractsCount: null,
        projectContracts: [],
        searchingProjectContracts: false,
        searchProjectContractStatus: null
    },
}
const mutations = {
    ['SET_INVESTOR_CONTRACT_CREATE'](state, change) {
        state.investorContractCreate = { ...state.investorContractCreate, ...change };
    },
    ['SET_INVESTOR_CONTRACT_UPDATE'](state, change) {
        state.investorContractUpdate = { ...state.investorContractUpdate, ...change };
    },
    ['SET_INVESTOR_CONTRACT_DELETE'](state, change) {
        state.investorContractDelete = { ...state.investorContractDelete, ...change };
    },
    ['SET_INVESTOR_CONTRACT_SEARCH'](state, change) {
        state.investorContractSearch = { ...state.investorContractSearch, ...change };
    },
    ['SET_PROJECT_CONTRACT_CREATE'](state, change) {
        state.projectContractCreate = { ...state.projectContractCreate, ...change };
    },
    ['SET_PROJECT_CONTRACT_UPDATE'](state, change) {
        state.projectContractUpdate = { ...state.projectContractUpdate, ...change };
    },
    ['SET_PROJECT_CONTRACT_DELETE'](state, change) {
        state.projectContractDelete = { ...state.projectContractDelete, ...change };
    },
    ['SET_PROJECT_CONTRACT_SEARCH'](state, change) {
        state.projectContractSearch = { ...state.projectContractSearch, ...change };
    }
}
const actions = {
    createInvestorContract: ({ commit }, payload) => {
        commit('SET_INVESTOR_CONTRACT_CREATE', { createInvestorContractStatus: null, createdInvestorContract: null, creatingInvestorContract: true })
        return Vue.http.post(API_URL + '/investors/contracts/create', payload).then(response => {
            commit('SET_INVESTOR_CONTRACT_CREATE', { createInvestorContractStatus: 'success', createdInvestorContract: response.body.results.investorContract });
        }).catch(response => {
            commit('SET_INVESTOR_CONTRACT_CREATE', { createInvestorContractStatus: 'failed' });
        }).finally(() => {
            commit('SET_INVESTOR_CONTRACT_CREATE', { creatingInvestorContract: false });
        });
    },
    updateInvestorContract: ({ commit }, payload) => {
        commit('SET_INVESTOR_CONTRACT_UPDATE', { updateInvestorContractStatus: null, updatedInvestorContract: null, updatingInvestorContract: true })
        return Vue.http.post(API_URL + '/investors/contracts/update/' + payload.id, payload)
            .then(response => {
                commit('SET_INVESTOR_CONTRACT_UPDATE', { updateInvestorContractStatus: 'success', updatedInvestorContract: response.body.results.investorContract });
            })
            .catch(response => {
                commit('SET_INVESTOR_CONTRACT_UPDATE', { updateInvestorContractStatus: 'failed' });
            })
            .finally(() => {
                commit('SET_INVESTOR_CONTRACT_UPDATE', { updatingInvestorContract: false });
            })
    },
    deleteInvestorContract: ({ commit }, id) => {
        commit('SET_INVESTOR_CONTRACT_DELETE', { deleteInvestorContractStatus: null, deletedInvestorContract: null, deletingInvestorContract: true })
        return Vue.http.delete(API_URL + '/investors/contracts/delete/' + id).then(response => {
            commit('SET_INVESTOR_CONTRACT_DELETE', { deleteInvestorContractStatus: 'success' });
        }).catch(response => {
            commit('SET_INVESTOR_CONTRACT_DELETE', { deleteInvestorContractStatus: 'failed' });
        }).finally(() => {
            commit('SET_INVESTOR_CONTRACT_DELETE', { deletingInvestorContract: false });
        })
    },
    searchInvestorContracts: ({ commit }, payload = { filter: InvestorContractsFilter(), resultMode: 'default' }) => {
        commit('SET_INVESTOR_CONTRACT_SEARCH', { searchInvestorContractStatus: null, searchInvestorContract: null, searchingInvestorContracts: true })
        let filerJson = JSON.stringify(payload.filter);
        switch (payload.resultMode) {
            case 'count': payload.resultMode = 1; break;
            case 'paginated': payload.resultMode = 2; break;
            case 'paginatedPersist': payload.resultMode = 21; break;
            default: payload.resultMode = 0; break;
        }
        var params = '?query=' + encodeURIComponent(filerJson) + '&result_mode=' + payload.resultMode;
        return Vue.http.get(API_URL + '/investors/contracts' + params).then(response => {
            commit('SET_INVESTOR_CONTRACT_SEARCH', { searchInvestorContractStatus: 'success', investorContracts: response.body.results.investorContracts });
        }).catch(response => {
            commit('SET_INVESTOR_CONTRACT_SEARCH', { searchInvestorContractStatus: 'failed' });
        }).finally(() => {
            commit('SET_INVESTOR_CONTRACT_SEARCH', { searchingInvestorContracts: false });
        })
    },
    confirmInvestorContract: ({ commit }, payload) => {
        commit('SET_INVESTOR_CONTRACT_UPDATE', { updateInvestorContractStatus: null, updatedInvestorContract: null, updatingInvestorContract: true })
        return Vue.http.post(API_URL + '/investors/contracts/confirm/' + payload.id, payload)
            .then(response => {
                commit('SET_INVESTOR_CONTRACT_UPDATE', { updateInvestorContractStatus: 'success', updatedInvestorContract: response.body.results.investorContract });
            })
            .catch(response => {
                commit('SET_INVESTOR_CONTRACT_UPDATE', { updateInvestorContractStatus: 'failed' });
            })
            .finally(() => {
                commit('SET_INVESTOR_CONTRACT_UPDATE', { updatingInvestorContract: false });
            })
    },
    createProjectContract: ({ commit }, payload) => {
        commit('SET_PROJECT_CONTRACT_CREATE', { createProjectContractStatus: null, createdProjectContract: null, creatingProjectContract: true })
        return Vue.http.post(API_URL + '/projects/contracts/create', payload).then(response => {
            commit('SET_PROJECT_CONTRACT_CREATE', { createProjectContractStatus: 'success', createdProjectContract: response.body.results.projectContract });
        }).catch(response => {
            commit('SET_PROJECT_CONTRACT_CREATE', { createProjectContractStatus: 'failed' });
        }).finally(() => {
            commit('SET_PROJECT_CONTRACT_CREATE', { creatingProjectContract: false });
        });
    },
    updateProjectContract: ({ commit }, payload) => {
        commit('SET_PROJECT_CONTRACT_UPDATE', { updateProjectContractStatus: null, updatedProjectContract: null, updatingProjectContract: true })
        return Vue.http.post(API_URL + '/projects/contracts/update/' + payload.id, payload)
            .then(response => {
                commit('SET_PROJECT_CONTRACT_UPDATE', { updateProjectContractStatus: 'success', updatedProjectContract: response.body.results.projectContract });
            })
            .catch(response => {
                commit('SET_PROJECT_CONTRACT_UPDATE', { updateProjectContractStatus: 'failed' });
            })
            .finally(() => {
                commit('SET_PROJECT_CONTRACT_UPDATE', { updatingProjectContract: false });
            })
    },
    deleteProjectContract: ({ commit }, id) => {
        commit('SET_PROJECT_CONTRACT_DELETE', { deleteProjectContractStatus: null, deletedProjectContract: null, deletingProjectContract: true })
        return Vue.http.delete(API_URL + '/projects/contracts/delete/' + id).then(response => {
            commit('SET_PROJECT_CONTRACT_DELETE', { deleteProjectContractStatus: 'success' });
        }).catch(response => {
            commit('SET_PROJECT_CONTRACT_DELETE', { deleteProjectContractStatus: 'failed' });
        }).finally(() => {
            commit('SET_PROJECT_CONTRACT_DELETE', { deletingProjectContract: false });
        })
    },
    searchProjectContracts: ({ commit }, payload = { filter: ProjectContractsFilter(), resultMode: 'default' }) => {
        commit('SET_PROJECT_CONTRACT_SEARCH', { searchProjectContractStatus: null, searchProjectContract: null, searchingProjectContracts: true })
        let filerJson = JSON.stringify(payload.filter);
        switch (payload.resultMode) {
            case 'count': payload.resultMode = 1; break;
            case 'paginated': payload.resultMode = 2; break;
            case 'paginatedPersist': payload.resultMode = 21; break;
            default: payload.resultMode = 0; break;
        }
        var params = '?query=' + encodeURIComponent(filerJson) + '&result_mode=' + payload.resultMode;
        return Vue.http.get(API_URL + '/projects/contracts' + params).then(response => {
            commit('SET_PROJECT_CONTRACT_SEARCH', { searchProjectContractStatus: 'success', projectContracts: response.body.results.projectContracts });
        }).catch(response => {
            commit('SET_PROJECT_CONTRACT_SEARCH', { searchProjectContractStatus: 'failed' });
        }).finally(() => {
            commit('SET_PROJECT_CONTRACT_SEARCH', { searchingProjectContracts: false });
        })
    },
}
export default {
    state, mutations, actions
} 



// WEBPACK FOOTER //
// ./resources/js/store/modules/contractStore.js